
















import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import ModuleBase from './ModuleBase'
import ModuleItemForm from '@/components/ModuleItemForm.vue'
import { ModuleDataItem } from '@/models/ModuleDataItem'
import Loader from '@/components/Loader.vue'

@Component({
	components: {
		ModuleItemForm,
		Loader,
	},
})
export default class EditModuleItem extends ModuleBase {

	get moduleItem() {
		return this.$store.getters.moduleItem(this.$route.params.id)
	}

	private updateModuleItem(item: ModuleDataItem) {
		item.set('moduleName', this.module.name)
		item.save().then((response: any) => {
			console.log(response)
			this.$toasted.success('Item updated')
		}, (error: any) => {
			item.reset()
			this.$toasted.error('Failed to update item')
			console.log(error)
		})
	}
}
